(function () {
  'use strict';
  function boot() {
    var L = window.LV, pd = document.getElementById('lv-product-json');
    if (!L || !pd) return;
    initProduct(JSON.parse(pd.textContent), L);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  function initProduct(product, L) {
    var $ = L.$, $$ = L.$$, esc = L.esc, addItems = L.addItems;
    var sec = $('[data-lv-product]');
    product.options = product.options.map(function (o) { return typeof o === 'string' ? o : o.name; });
    var optValues = product.options.map(function (_, i) { var seen = []; product.variants.forEach(function (v) { if (seen.indexOf(v.options[i]) < 0) seen.push(v.options[i]); }); return seen; });
    var colorIdx = product.options.indexOf('Color'), sizeIdx = product.options.indexOf('Size');
    var first = product.variants.find(function (v) { return v.available; }) || product.variants[0];
    var state = { color: first.options[colorIdx], size: first.options[sizeIdx], bundle: 1, units: [], g: 0 };
    var colorImgs = JSON.parse($('#lv-color-images').textContent);
    var hexes = { 'Black': '#1F1B1E', 'Cream White': '#F1E9DF', 'Mocha Brown': '#7A5F55', 'Foundation Nude': '#DDB799' };
    function findVariant(c, s) { return product.variants.find(function (v) { return v.options[colorIdx] === c && v.options[sizeIdx] === s; }); }

    var gSlides = $$('[data-g]', sec), gThumbs = $$('[data-g-thumb]', sec), gCount = $('[data-g-count]', sec), mainImg = $('[data-g-color]', sec);
    function gGo(k) {
      state.g = (k + gSlides.length) % gSlides.length;
      gSlides.forEach(function (s, i) { s.style.opacity = i === state.g ? 1 : 0; s.style.transform = 'scale(' + (i === state.g ? 1 : 1.03) + ')'; });
      gThumbs.forEach(function (t, i) { t.setAttribute('aria-pressed', i === state.g); t.style.boxShadow = i === state.g ? '0 0 0 2px #6E3854' : 'none'; });
      if (gCount) gCount.textContent = (state.g + 1) + ' / ' + gSlides.length;
    }
    gThumbs.forEach(function (t, i) { t.addEventListener('click', function () { gGo(i); }); });
    var gp = $('[data-g-prev]', sec), gn = $('[data-g-next]', sec);
    if (gp) gp.addEventListener('click', function () { gGo(state.g - 1); });
    if (gn) gn.addEventListener('click', function () { gGo(state.g + 1); });

    var swatches = $$('[data-color]', sec), sizes = $$('[data-size]', sec);
    function pillOn(el, on) { el.setAttribute('aria-pressed', on); el.style.background = on ? '#6E3854' : '#FFFFFF'; el.style.color = on ? '#FFFFFF' : '#171317'; el.style.borderColor = on ? '#6E3854' : '#DEC8D2'; }
    function renderOptions() {
      swatches.forEach(function (b) { var on = b.getAttribute('data-color') === state.color; b.setAttribute('aria-pressed', on); $('.sw', b).style.boxShadow = on ? '0 0 0 2px #FFFFFF, 0 0 0 4px #6E3854' : '0 0 0 1px #CDB5C0'; });
      sizes.forEach(function (b) {
        var v = findVariant(state.color, b.getAttribute('data-size'));
        pillOn(b, b.getAttribute('data-size') === state.size);
        b.style.textDecoration = v && !v.available ? 'line-through' : 'none';
      });
      $$('[data-color-name]', sec).forEach(function (el) { el.textContent = state.color; });
      if (mainImg && colorImgs[state.color]) mainImg.src = colorImgs[state.color];
      var thumb0 = gThumbs[0] && $('img', gThumbs[0]); if (thumb0 && colorImgs[state.color]) thumb0.src = colorImgs[state.color];
      $$('[data-sticky-img]').forEach(function (el) { if (colorImgs[state.color]) el.src = colorImgs[state.color]; });
      $$('[data-sticky-name]').forEach(function (el) { el.textContent = 'Lock & Lift · ' + state.color + ' · ' + state.size; });
      renderPairs(); renderUnits(); renderAtc();
    }
    swatches.forEach(function (b) { b.addEventListener('click', function () { state.color = b.getAttribute('data-color'); gGo(0); renderOptions(); }); });
    sizes.forEach(function (b) { b.addEventListener('click', function () { state.size = b.getAttribute('data-size'); renderOptions(); }); });

    var bundles = $$('[data-bundle]', sec), unitsBox = $('[data-units]', sec);
    function renderBundles() {
      bundles.forEach(function (b) {
        var on = +b.getAttribute('data-bundle') === state.bundle;
        b.classList.toggle('is-on', on);
        var h = $('.bundle-head', b); if (h) h.setAttribute('aria-pressed', on);
        var r = $('.radio', b);
        if (r) { r.style.boxShadow = on ? 'inset 0 0 0 2px #6E3854' : 'inset 0 0 0 1.5px #B9A3AE'; r.style.background = on ? 'radial-gradient(circle, #6E3854 0 42%, #FFFFFF 46%)' : '#FFFFFF'; }
        if (on && unitsBox && unitsBox.parentNode !== b) b.appendChild(unitsBox);
      });
    }
    function optionsHtml(values, sel) { return values.map(function (v) { return '<option' + (v === sel ? ' selected' : '') + '>' + esc(v) + '</option>'; }).join(''); }
    function renderUnits() {
      if (!unitsBox) return;
      if (state.bundle <= 1) { unitsBox.innerHTML = ''; unitsBox.hidden = true; return; }
      while (state.units.length < state.bundle) state.units.push({ color: state.color, size: state.size });
      state.units.length = state.bundle;
      state.units[0] = { color: state.color, size: state.size };
      unitsBox.hidden = false;
      unitsBox.innerHTML = '<p class="u-label">Color, Size</p>' + state.units.map(function (u, i) {
        return '<div class="u-row"><img src="' + esc(colorImgs[u.color] || '') + '" alt="">' +
          '<div class="u-sel"><span class="u-color"><span class="u-dot" style="background:' + (hexes[u.color] || '#DDB799') + '"></span>' +
          '<label class="sr-only" for="u-c-' + i + '">Color for item ' + (i + 1) + '</label><select id="u-c-' + i + '" data-unit-color="' + i + '">' + optionsHtml(optValues[colorIdx], u.color) + '</select></span>' +
          '<label class="sr-only" for="u-s-' + i + '">Size for item ' + (i + 1) + '</label><select class="u-size" id="u-s-' + i + '" data-unit-size="' + i + '">' + optionsHtml(optValues[sizeIdx], u.size) + '</select></div></div>';
      }).join('');
    }
    if (unitsBox) unitsBox.addEventListener('change', function (e) {
      var c = e.target.getAttribute('data-unit-color'), s = e.target.getAttribute('data-unit-size');
      if (c !== null) { state.units[+c].color = e.target.value; if (+c === 0) { state.color = e.target.value; renderOptions(); } else renderUnits(); }
      if (s !== null) { state.units[+s].size = e.target.value; if (+s === 0) { state.size = e.target.value; renderOptions(); } }
    });
    bundles.forEach(function (b) { var h = $('.bundle-head', b) || b; h.addEventListener('click', function () { state.bundle = +b.getAttribute('data-bundle'); renderBundles(); renderUnits(); renderAtc(); }); });

    var atcBtns = $$('[data-atc]'), msg = $('[data-atc-msg]', sec);
    function renderAtc() {
      var v = findVariant(state.color, state.size);
      var bEl = bundles.length ? $('[data-bundle="' + state.bundle + '"]', sec) : null;
      var price = bEl ? bEl.getAttribute('data-price-label') : '';
      atcBtns.forEach(function (b) {
        var ok = v && v.available;
        b.disabled = !ok;
        $$('[data-atc-label]', b).forEach(function (l) { l.textContent = ok ? ('ADD TO CART' + (price && b.hasAttribute('data-show-price') ? ' · ' + price : '')) : 'SOLD OUT'; });
      });
    }
    function lineItems() {
      if (state.bundle <= 1) { var v = findVariant(state.color, state.size); return v ? [{ id: v.id, quantity: 1 }] : []; }
      var map = {};
      state.units.forEach(function (u) { var v = findVariant(u.color, u.size); if (v) map[v.id] = (map[v.id] || 0) + 1; });
      return Object.keys(map).map(function (id) { return { id: +id, quantity: map[id] }; });
    }
    atcBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var items = lineItems();
        if (!items.length) return;
        atcBtns.forEach(function (x) { x.disabled = true; });
        if (msg) msg.textContent = '';
        addItems(items).catch(function (err) { if (msg) msg.textContent = err.message; }).finally(renderAtc);
      });
    });

    var pairsBox = $('[data-pairs]', sec);
    function renderPairs() {
      if (!pairsBox) return;
      $$('[data-pair]', pairsBox).forEach(function (row) {
        var c = row.getAttribute('data-pair');
        row.hidden = c === state.color;
        var v = findVariant(c, state.size);
        var btn = $('button', row);
        btn.disabled = !(v && v.available);
        btn.onclick = function () { if (v) { btn.disabled = true; addItems([{ id: v.id, quantity: 1 }]).finally(function () { btn.disabled = false; }); } };
        $('[data-pair-size]', row).textContent = state.size;
      });
    }

    var tabs = $$('[role="tab"]', sec), panels = $$('[role="tabpanel"]', sec);
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x, j) { var on = j === i; x.setAttribute('aria-selected', on); x.style.color = on ? '#4C253B' : '#7A6B72'; x.style.borderBottomColor = on ? '#6E3854' : 'transparent'; x.style.background = on ? '#FFFFFF' : 'transparent'; panels[j].hidden = !on; });
      });
    });

    var sg = $('[data-sg]');
    var unit = 'in', band = null, cup = null;
    function openSg() { if (sg) { sg.hidden = false; $('[data-sg-close].iconbtn', sg).focus(); } }
    function closeSg() { if (sg) sg.hidden = true; }
    function segOn(el, on) { el.setAttribute('aria-pressed', on); el.style.background = on ? '#6E3854' : 'transparent'; el.style.color = on ? '#FFFFFF' : '#4C253B'; }
    function sgRender() {
      $$('[data-unit]', sg).forEach(function (x) { segOn(x, x.getAttribute('data-unit') === unit); });
      $$('[data-in]', sg).forEach(function (c) { c.textContent = c.getAttribute(unit === 'in' ? 'data-in' : 'data-cm'); });
      $$('[data-band]', sg).forEach(function (x) { pillOn(x, x.getAttribute('data-band') === band); });
      $$('[data-cup]', sg).forEach(function (x) { pillOn(x, x.getAttribute('data-cup') === cup); });
      var map = { '32': 'S', '34': 'M', '36': 'L', '38': 'XL' };
      var t = $('[data-rec-title]', sg), tx = $('[data-rec-text]', sg), ap = $('[data-rec-apply]', sg);
      ap.hidden = true;
      if (!band || !cup) { t.textContent = 'Select your band and cup'; tx.textContent = 'We’ll match you to a Lock & Lift size.'; return; }
      if (map[band] && ['A', 'B', 'C'].indexOf(cup) >= 0) {
        var sz = map[band];
        var label = optValues[sizeIdx].find(function (v) { return v.split(' ')[0] === sz; }) || sz;
        t.textContent = 'Your size: ' + sz;
        tx.textContent = 'Size ' + sz + ' fits ' + band + 'A, ' + band + 'B and ' + band + 'C. Check your underbust against the chart to confirm.';
        ap.hidden = false; ap.setAttribute('data-size-label', label); ap.textContent = 'SELECT SIZE ' + sz;
      } else {
        t.textContent = 'Not available in ' + band + cup + ' yet';
        tx.textContent = 'The Lock & Lift comes in bands 32–38 with A–C cups. We’d rather tell you now than have it not fit.';
      }
    }
    $$('[data-sg-open]').forEach(function (b) { b.addEventListener('click', openSg); });
    if (sg) {
      $$('[data-sg-close]', sg).forEach(function (b) { b.addEventListener('click', closeSg); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sg.hidden) closeSg(); });
      $$('[data-unit]', sg).forEach(function (b) { b.addEventListener('click', function () { unit = b.getAttribute('data-unit'); sgRender(); }); });
      $$('[data-view]', sg).forEach(function (b) { b.addEventListener('click', function () { $$('[data-view-panel]', sg).forEach(function (p) { p.hidden = p.getAttribute('data-view-panel') !== b.getAttribute('data-view'); }); $$('[data-view]', sg).forEach(function (x) { segOn(x, x === b); }); }); });
      $$('[data-band]', sg).forEach(function (b) { b.addEventListener('click', function () { band = b.getAttribute('data-band'); sgRender(); }); });
      $$('[data-cup]', sg).forEach(function (b) { b.addEventListener('click', function () { cup = b.getAttribute('data-cup'); sgRender(); }); });
      var apply = $('[data-rec-apply]', sg);
      if (apply) apply.addEventListener('click', function () { var target = apply.getAttribute('data-size-label'); if (target) { state.size = target; renderOptions(); } closeSg(); });
      sgRender();
    }

    var sticky = $('[data-sticky]'), buy = $('[data-buybox]', sec);
    if (sticky && buy && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var show = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        sticky.style.transform = show ? 'translateY(0)' : 'translateY(110%)';
        sticky.setAttribute('aria-hidden', !show);
      }).observe(buy);
    }

    gGo(0); renderBundles(); renderOptions();
  }
})();